export const EXPERIMENT_OFFERS_FEATURE_FLAG_NAME = 'offersPaintedDoorPartnerWhiteList';

export const PAYPAL_UPSELL_BANNER_ANALYTICS_ID = 'paypal-upsell-banner';
export const PAYPAL_UPSELL_MODAL_ANALYTICS_ID = 'paypal-modal';
